export const apiTravelPricingRoutes = {
    routePricing: 'driver/prices'
}